import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH } from './constants';

/**
 * Redirección permanente desde el generador legacy de residuos.
 * Conserva query/hash por si algún enlace antiguo los envía.
 */
const ResidueGuideRegisterRedirect = () => {
	const location = useLocation();

	useEffect(() => {
		toast.info(
			'El generador de guías en Residuos fue reemplazado por el generador unificado de Bodega.',
			{ autoClose: 6000 },
		);
	}, []);

	const params = new URLSearchParams(location.search);
	if (!params.has('category')) {
		params.set('category', 'residuos');
	}
	const qs = params.toString();
	const target = `/warehouse/guide/register${qs ? `?${qs}` : '?category=residuos'}${location.hash || ''}`;

	return <Navigate to={target} replace />;
};

export default ResidueGuideRegisterRedirect;
